angular
  .module('app')
  .component('internshipsComponent', {
    templateUrl: 'app/components/internships/internships.tmpl.html',
    controller: function ($http, appConfig, modalService, categoryValues, $location, anchorSmoothScroll,
                          localStorageService, authService) {
      var vm = this;
      vm.hueModel = 'VERTICAL';
      vm.yearModel = 'YEAR';
      vm.year = [];
      vm.hue = categoryValues('hue');
      vm.showSchoolModal = false;
      vm.showDateModal = false;
      vm.selectedSchool = '';
      vm.selectedDate = '';
      vm.selectedYear = '';
      vm.pageData = {};
      vm.schoolData = [];
      vm.items = [];
      vm.flag = true;
      let numberOfElements = 12;
      let count = 1;
      vm.date = [
        { index: 1, id: 'January', title: 'JANUARY', isdisabled: false},
        { index: 2, id: 'February', title: 'FEBRUARY', isdisabled: false},
        { index: 3, id: 'March', title: 'MARCH', isdisabled: false},
        { index: 4, id: 'April', title: 'APRIL', isdisabled: false},
        { index: 5, id: 'May', title: 'MAY', isdisabled: false},
        { index: 6, id: 'June', title: 'JUNE', isdisabled: false},
        { index: 7, id: 'July', title: 'JULY', isdisabled: false},
        { index: 8, id: 'August', title: 'AUGUST', isdisabled: false},
        { index: 9, id: 'September', title: 'SEPTEMBER', isdisabled: false},
        { index: 10, id: 'October', title: 'OCTOBER', isdisabled: false},
        { index: 11, id: 'November', title: 'NOVEMBER', isdisabled: false},
        { index: 12, id: 'December', title: 'DECEMBER', isdisabled: false},
      ]

      vm.init = function () {
        const school = vm.selectedSchool ? vm.selectedSchool : '';
        const date = vm.selectedDate ? vm.selectedDate.index : '';
        const year = vm.selectedYear ? vm.selectedYear : '';
        $http.get(appConfig.dashboardServiceUrl + `api/internship_projects/dashboard?published_month=` + date + `&published_year=` + year + `&d_school_name=` + school, {params: {token: authService.token}})
          .then(function (res) {
            vm.pageData = res.data.internship_projects;
            vm.select();
          });
      };

      vm.schoolList = function () {
        $http.get(appConfig.dashboardServiceUrl + `api/internship_projects/dashboard/schools`, {params: {token: authService.token}})
          .then(function (res) {
            vm.schoolData = res.data;
          });
      };
      vm.schoolList();

      vm.sortItems = function () {
        vm.filterData.forEach(function (elem, index) {
          if (index > numberOfElements * count - 1) {
            elem.style = 'display: none';
            vm.flag = false;
          } else {
            elem.style = '';
            vm.flag = true;
          }
          elem.description = `<p>${elem.description}</p>`;
          elem.header = elem.header[0] + elem.header.slice(1).toLowerCase();
          vm.items.push(elem);
        });
      };

      vm.more = function () {
        vm.items = [];
        count++;
        vm.sortItems();
      };

      vm.onGraphicClick = function (event) {
        window.parent.postMessage({
          action: "OpenProjectInternshipModal", data: {
              projectData: event
          }
        })
      };

      vm.select = function () {
        if (vm.hue.includes(vm.hueModel) || vm.year.includes(Number(vm.yearModel))) {
          vm.filterData = angular.copy(vm.pageData.filter(function (t) {
            if ((!vm.hue.includes(vm.hueModel) || vm.hueModel === t.hue) &&
              (!vm.year.includes(Number(vm.yearModel)) || vm.yearModel === t.published_year)) {
              return t;
            }
          }));
        } else {
          vm.filterData = angular.copy(vm.pageData);
        }
        count = 1;
        vm.items = [];
        vm.sortItems();
      };

      vm.gotoElement = function (eID) {
        $location.hash('prefooter');
        anchorSmoothScroll.scrollTo(eID);
        $location.hash('');
      };

      vm.getUser = function () {
        return localStorageService.get('currentUser').id === undefined;
      };

      vm.makeDate = function (item) {
          return moment(item.published_year + '-' + item.published_month + '-' + item.published_day).format('MMMM D, YYYY');
      };
      vm.toggleSchoolDetails = function() {
        vm.showSchoolModal = !vm.showSchoolModal;
      };
      vm.toggleDateDetails = function() {
        vm.showDateModal = !vm.showDateModal;
      };
      vm.filterDate = function(data, year) {
        vm.showDateModal = !vm.showDateModal;
        vm.selectedYear = year;
        vm.selectedDate = data;
        vm.init();
      };
      vm.filterSchool = function(data) {
        vm.showSchoolModal = !vm.showSchoolModal;
        vm.selectedSchool = data;
        vm.init();
      };
      vm.allProjects = function() {
        vm.selectedYear = '';
        vm.selectedDate = '';
        vm.selectedSchool = '';
        vm.init();
      };
    }
  });
